module.exports = __webpack_public_path__ + "static/media/022.0298a6ab.jpg";